
import { motion } from "framer-motion";

interface QuizProgressBarProps {
  percentage: number;
}

const QuizProgressBar = ({ percentage }: QuizProgressBarProps) => {
  return (
    <motion.div 
      className="w-full max-w-md mb-8"
      initial={{ width: 0, opacity: 0 }}
      animate={{ width: "100%", opacity: 1 }}
      transition={{ delay: 0.7, duration: 0.5 }}
    >
      <div className="h-10 bg-gray-100 rounded-full overflow-hidden shadow-inner border border-gray-200">
        <motion.div 
          className="h-full bg-gradient-to-r from-corporate-secondary-100 to-corporate-secondary-75 flex items-center justify-center"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 1.2, delay: 0.8, ease: "easeOut" }}
        >
          <span className="text-white font-medium text-sm">{percentage}%</span>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default QuizProgressBar;
